import firebase from 'firebase';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyDoIRAbfdDYrE26ZgaQg6nvSQhTT9elNSM',
  authDomain: 'disney-clone-a82dc.firebaseapp.com',
  projectId: 'disney-clone-a82dc',
  storageBucket: 'disney-clone-a82dc.appspot.com',
  messagingSenderId: '1064107056762',
  appId: '1:1064107056762:web:4fce512d5dde041b6325c3',
  measurementId: 'G-9RZEXR81QR',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebaseApp.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage();

export { storage, auth, provider };

export default db;
